exports = module.exports = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".style-customize-bullets-PN24r{margin-right:20px;font-size:12px}.style-customize-bullets-label-3g3My{font-size:12px;margin-bottom:5px}.style-customize-bullets-input-container-1Y7I9{display:flex;align-items:center}.style-customize-bullets-input-container-1Y7I9 .style-customize-bullets-input--X_M-{width:50px;height:28px;padding:5px 2px}.style-customize-bullets-input-container-1Y7I9 .style-image-upload-btn-doktm{margin-left:6px}", ""]);

// Exports
exports.locals = {
	"customize-bullets": "style-customize-bullets-PN24r",
	"customize-bullets-label": "style-customize-bullets-label-3g3My",
	"customize-bullets-input-container": "style-customize-bullets-input-container-1Y7I9",
	"customize-bullets-input": "style-customize-bullets-input--X_M-",
	"image-upload-btn": "style-image-upload-btn-doktm"
};